import { Component, OnInit } from '@angular/core';
import { BaseTabsContainer, TabsContainerService, UserService } from 'yt-ng-framework';
import { ZaposleniView } from './zaposleni-view';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-zaposleni-tabs',
  templateUrl: './zaposleni-tabs.component.html',
  providers: [TabsContainerService]
})
export class ZaposleniTabsComponent
  extends BaseTabsContainer<ZaposleniView>
  implements OnInit {

  constructor(
    public tabsContainerService: TabsContainerService<ZaposleniView>,
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService,
  ) { 
    super(tabsContainerService, activatedRoute, userService)
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
